import gql from 'graphql-tag';

const APPROVE_ATTENDANCE = gql`
  mutation approveEventAttendance($token: String!) {
    approveEventAttendance(token: $token)
  }
`;

export default APPROVE_ATTENDANCE;
